import React from 'react';
import { VoteSingleSelect } from './type/VoteSingleSelect';
import { VoteMultiSelect } from './type/VoteMultiSelect';
import { VoteRanked } from './type/VoteRanked';
import { VoteQuestionnaire } from './type/VoteQuestionnaire';
import { VoteSurvey } from './type/VoteSurvey';
import dompurify from 'dompurify';
import { VoteIBPSA } from './type/VoteIBPSA';

export const VoteGroup = ({ currentGroup, currentGroupVote, handleOptionsUpdate, ballot, isJustSubmitted }) => {
    return (
        <>
            {currentGroup.groupDescription &&
                <div className="mb-4">
                    <span dangerouslySetInnerHTML={{ __html: dompurify.sanitize(currentGroup.groupDescription) }} />
                </div>
            }
            {currentGroup.groupType === "BallotSingle" &&
                <VoteSingleSelect options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate}
                    group={currentGroup} />}
            {currentGroup.groupType.startsWith("BallotMulti") &&
                <VoteMultiSelect options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate}
                    group={currentGroup} />}
            {currentGroup.groupType.startsWith("Ranked") &&
                <VoteRanked options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate}
                    group={currentGroup} />}
            {currentGroup.groupType === "Questionnaire" &&
                <VoteQuestionnaire options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate} />}
            {currentGroup.groupType === "Survey" &&
                <VoteSurvey options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate} />}
            {currentGroup.groupType === "IBPSA" &&
                <VoteIBPSA options={currentGroup.options}
                    hasVoted={currentGroupVote.hasVoted && !ballot.isVoteChange}
                    onOptionsUpdate={handleOptionsUpdate}
                    group={currentGroup} />}
        </>
    );
}